import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router/index.js'
import firebase from './Firebase'
import App from './App.vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

let app = '';

Vue.use(VueRouter)
Vue.use(BootstrapVue)

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app');
  }
});

